import { render, staticRenderFns } from "./AutoinvestmentStrategy.vue?vue&type=template&id=20414cd4&"
import script from "./AutoinvestmentStrategy.vue?vue&type=script&lang=js&"
export * from "./AutoinvestmentStrategy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports